import { render } from "./HeroiconsSolidLogin.vue?vue&type=template&id=611acd21"
const script = {}

import exportComponent from "/var/www/doughcoteam.co.uk/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidLogin.vue"]])

export default __exports__